function measureTextPixels(pText, pFontSize) {
  let lDiv: null | HTMLDivElement = document.createElement('div')
  document.body.appendChild(lDiv)
  lDiv.style.fontSize = `${pFontSize}px`
  lDiv.style.position = 'absolute'
  lDiv.style.left = '-1000'
  lDiv.style.top = '-1000'
  lDiv.textContent = pText
  const width = lDiv.clientWidth
  document.body.removeChild(lDiv)
  lDiv = null
  return width
}

export default measureTextPixels
